import { FaRegEdit } from "react-icons/fa";
import { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, Col, OverlayTrigger, Popover } from "react-bootstrap";
import { Tooltip } from "primereact/tooltip";
// import { Toast } from "primereact/toast";
import { toast } from "react-toastify";

import DatePicker from "react-date-picker";
import {
  HiOutlineCalendar,
  HiOutlineSearch,
  HiOutlinePlusSm,
} from "react-icons/hi";
import { MdOutlineClear } from "react-icons/md";

import { deleteRequest, getRequest } from "../../actions/Handler";
import PTable from "../../components/table/table";
import BreadCrum from "../../components/breadcrums/breadcrum";
import Cards from "../../components/cards/cards";
import PrimaryModal from "../../components/modal/primaryReview/primaryReview";
import InspectionModel from "../../components/modal/inspection/inspection";
import CompleteRecommendation from "../../components/modal/completeRecommendation/completeRecommendation";
import CreateEvent from "../../components/modal/createEvent/createEvent";
import "./risk-event-reports.css";
import "../../components/table/table.css";
import DeleteConfirmation from "../../components/modal/deleteConfirmation/deleteConfirmation";
import { postRequest } from "../../actions/Handler";
import { InputText } from "primereact/inputtext";
import { BiDownload } from "react-icons/bi";
export interface LoadingProps {
  cards: boolean;
  table: boolean;
}
export default function RiskEventReports(props: any) {
  const navigate = useNavigate();
  const currentPage = "all-reports";
  const [eventReportId, setEventReportId] = useState("");
  const [from, fromChange] = useState();
  const [to, toChange] = useState();
  const [search, setSearch] = useState(() => {
    const storedSearch = sessionStorage.getItem("search");
    return storedSearch ? JSON.parse(storedSearch) : "";
  });
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const { reviewType, eventId } = useParams();

  const [dateFormat, setDateFormat] = useState({
    from: "MMddy",
    fromCross: "none",
    to: "MMddy",
    toCross: "none",
  });
  const dateFilter = () => {
    return true;
  };

  let userDetail = JSON.parse(
    sessionStorage.getItem("userDetail") || "{}"
  ) as any;

  const siteReviewer = "Site Reviewer";
  const centralUser = "Central User";
  const regionalUser = "Regional User";

  let isCentralOrRegionalUser: boolean = false;
  let isCentralUser: boolean = false;
  let isSiteUser: boolean = false;

  if (userDetail.role === siteReviewer) {
    isSiteUser = true;
  }
  if (userDetail.role === centralUser || userDetail.role === regionalUser) {
    isCentralOrRegionalUser = true;
  }
  if (userDetail.role === centralUser) {
    isCentralUser = true;
  }
  const buttonCss = {
    color: "#fff",
    background: "#316a9e",
    border: "1px solid #316a9e",
    padding: "0.2rem 0.7rem",
    transition:
      "background-color .2s,color .2s,border-color .2s,box-shadow .2s",
    borderRadius: "3px",
    fontSize: "12px",
  };

  const [filterLoader, setFilterLoader] = useState(false);
  const [showPrimary, setPrimaryShow] = useState(false);
  const [popupName, setPopupName] = useState("Primary Review");
  const [popupReadOnly, setPopupReadOnly] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [viewInspection, setViewInspection] = useState(false);

  interface RecommendationRowProps {
    eventReportKey: number;
    recommendationStartText: String;
    recommendationText: String;
    recommendationCompletedBy: String;
    recommendationCompletedOn: String;
    reviewType: String;
  }

  interface AttachmentRowProps {
    eventReportReviewAttachmentId: number;
    fileCategory: string;
    fileName: string;
    fileContent: string;
  }
  const [attachmentRow] = useState<AttachmentRowProps[]>([]);
  const [recommendationRow] = useState<RecommendationRowProps[]>([]);

  const [reviewDetail, setReviewDetail] = useState({
    recordHash: "",
    eventReportKey: 0,
    reviewType: "",
    analysisType: "",
    hasRecommendation: false,
    reviewComment: "",
    reviewScoringKey: undefined,
    reportReviewAttachments: attachmentRow,
    reviewRecommendations: recommendationRow,
    reviewRecommendationsCompletedOn: undefined,
    reviewRecommendationsCompletedBy: "",
    reviewCompletedBy: "",
    reviewCompletedOn: undefined,
    siteName:""
  });

  const [showInspection, setInspectionShow] = useState(false);
  const [erRowData, setERRowData] = useState();
  const [showRecommendation, setRecommendationShow] = useState(false);
  const [showCreateEvent, setCreateEventShow] = useState(false);
  const [reloadTable, setReloadTable] = useState(false);
  const [reloadCard, setReloadCard] = useState(false);
  const [eventTitle, setEventTitle] = useState("");

  const [statusOptions, setStatusOptions] = useState([]);
  const [reviewStatusOptions, setReviewStatusOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);

  const primaryPopup = () => setPrimaryShow((state) => !state);
  const recommendationPopup = () => setRecommendationShow((state) => !state);
  const createEventPopup = () => setCreateEventShow((state) => !state);
  const setReloadTableVal = () => setReloadTable((state) => !state);
  const setReloadCardVal = () => setReloadCard((state) => !state);
  const inspectionPopup = (props: any) => {
    setInspectionShow((state) => !state);
    setERRowData(props);
    setEventTitle(getEventReportTitle(props));
  };
  const inspectionViewPopup = (props: any) => {
    getInspection(props)
  };
  const reloadTableRef = useRef<any>();

  const errormess = () => {
    toast("Something went wrong!", {
      type: "error",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      sessionStorage.setItem("search", JSON.stringify(search)) 
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (reviewType =="SecondaryReview") {
      setEventReportId(eventId||"");
      getReviewDetails(eventId, "Secondary Review");
    } 
    if (reviewType =="Inspection") {
      setViewInspection(true);
      setEventReportId(eventId||"");
      getInspection(eventId||"")
    }
  }, [reviewType]); 



  const exportExcel=()=>{
    getRequest({ url: "api/EventReport/EventReportExcelExport",responseType:"blob" })
        .then((res) => {
              // Handle the response which is expected to be a blob (Excel file)
        const fileBlob = res;
        console.log(fileBlob)
        // Create a link element
        const link = document.createElement('a');
        
        // Create a URL for the blob object
        const url = window.URL.createObjectURL(fileBlob);
        
        // Set up the download attribute
        link.href = url;
        link.setAttribute('download', 'EventReport.xlsx'); // You can change the filename here
        
        // Append the link to the DOM
        document.body.appendChild(link);
        
        // Trigger the download by clicking the link
        link.click();
        
        // Clean up: remove the link after triggering the download
        document.body.removeChild(link);
        
        // Optionally, revoke the object URL
        window.URL.revokeObjectURL(url);
        })
        .catch((e) => {
          
        });
  }


  const getReviewDetails = (eventReportId: any, reviewType: string) => {
    var type = reviewType === "Primary Review" ? 1 : 2;
    getRequest({
      url:
        "api/eventReportReview/GetReviewDetails?eventReportId=" +
        eventReportId +
        "&reviewType=" +
        type,
    }).then((res) => {
      if (res != undefined) {
        res.reviewCompletedDate = SetDateToLocale(new Date(res.reviewCompletedDate));
        res.eventReportId=res.eventReportKey
        setReviewDetail(res);
        setPopupName(reviewType);
        setPopupReadOnly(true);
        primaryPopup();
        setEventTitle(getEventReportTitle(res));
      }
    })
      .catch(
        (e: any) => {
          console.log(e);
          errormess();
        }
      )
  };

  const getInspection = (eventReportId: string) => {
    var getUrl = "api/EventReportInspection/Get?eventReportId=" + eventReportId;

    getRequest({ url: getUrl })
      .then((res) => {
        if (
          res &&
          res.eventReportId &&
          res.eventReportId.toString() === eventReportId
        ) {
          res.inspectionCompletedOn = SetDateToLocale(new Date(res.inspectionCompletedOn));
          res.sharedCommentaryText=res?.sharedCommentary?.comment
          setERRowData(res);
          setEventTitle(getEventReportTitle(res));
          setInspectionShow((state) => !state);

        } 
      })
      .catch(() => {
        
      });
  };
 
  

  const SetDateToLocale = (dt: Date) => {
    var date = new Date(dt);
    var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
  }
  const redirectEventReport = (rowData: any) => {
    const mode = rowData.status === "Draft" ? "edit" : "view";
    navigate(`/event/report/${mode}/${rowData.eventReportId}`, {
      state: {
        eventId: rowData.eventReportId,
        page: "all-reports",
      },
    });
  };
  const reloadData = (fn: any) => {
    reloadTableRef.current = fn;
  };

  const onExit = () => {
    if (reloadTableRef.current) {
      reloadTableRef.current();
    }
  };

  const getEventReportTitle = (data: any) => {
    var title = "";
    var ageUnit = "";
    var age = null;
    if (data !== undefined) {
      if (data.ageUnit === "Months" && +data.age > 23) {
        ageUnit = "y.o. ";
        age = Math.floor(data.age / 12);
      } else {
        ageUnit =
          data.ageUnit === "Year"
            ? "y.o. "
            : data.ageUnit === "Months"
              ? "m.o. "
              : "";
        age = data.age;
      }


      title = `${age === null ? "" : age} ${ageUnit}`;
      title = `${title}${data.gender || ""} ${(data.age !== null && data.ageUnit) || data.gender ? "with" : ""
        } `;
      if (data.subCategory) {
        title = title + `${data.subCategory} on `;
      }

      var dt = SetDateToLocale(new Date(data.dos));
      let formatedDate = dt.getMonth() + 1 + '/' + dt.getDate() + '/' + dt.getFullYear()
      title = title + `${formatedDate} at ${data.siteName}`;
      title = title + ` (${data.eventReportId})`;
    }
    return title;

  };
  // const toast = useRef<Toast>(null);
  const ShowDeleteSuccessMessage = () => {
    toast("Event Report deleted successfully", {
      type: "success",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };
  const ShowErrorMessage = () => {
    toast("Something went wrong!", {
      type: "error",
      autoClose: 2000,
      pauseOnHover: true,
      delay: 0,
    });
  };

  const [test, setTest] = useState(false);

  const [deletePopup, setDeletePopup] = useState({
    showPopup: false,
    popupMessage: "",
    popupType: "",
    data: null,
    confirm: false,
  });

  useEffect(() => {
    if (deletePopup.confirm) {
      deleteRequest({
        url:
          "api/EventReport/DeleteEventReport?eventReportId=" +
          deletePopup["data"],
      }).then((res: any) => {
        setTest(!test);
        ShowDeleteSuccessMessage();
        // onExit();
        setReloadTableVal();
      });
    }
  }, [deletePopup]);
  useEffect(() => {
    Promise.all([GetStatusOptions(), GetReviewStatusOptions(), GetRegionOptions()]).then(
      (res: any) => {
        if (res[0] !== "") {
          setStatusOptions(res[0]);
        }
        if (res[1] !== "") {
          setReviewStatusOptions(res[1]);
        }
        if (res[2] !== "") {
          setRegionOptions(res[2]);
        }
      }
    );
  }, []);

  //get region list
  const GetRegionOptions = async () => {
    return new Promise((resolve, reject) => {
      getRequest({ url: "api/Region/GetRegions" })
        .then((res) => {
          var value = [];
          value = [
            ...res.map((val: any) => {
              return {
                name: val.name,
                value: val.name,
              };
            }),
          ];
          return resolve(value);
        })
        .catch((e) => {
          return resolve(e);
        });
    });
  };

  const GetStatusOptions = async () => {
    return new Promise((resolve, reject) => {
      getRequest({ url: "api/EventReport/GetEventStatuses" })
        .then((res) => {
          var value = [];
          value = [
            ...res.map((val: any) => {
              return {
                name: val.eventStatusName,
                value: val.eventStatusName,
              };
            }),
          ];
          return resolve(value);
        })
        .catch((e) => {
          return resolve(e);
        });
    });
  };
  const GetReviewStatusOptions = async () => {
    return new Promise((resolve, reject) => {
      getRequest({ url: "api/EventReportReview/GetReviewStatuses" })
        .then((res) => {
          var value = [
            {
              name: "(blank)",
              value: "null",
            },
          ];
          value = [
            ...value,
            ...res.map((val: any) => {
              return {
                name: val.eventReviewStatusName,
                value: val.eventReviewStatusName,
              };
            }),
          ];
          return resolve(value);
        })
        .catch((e) => {
          return resolve(e);
        });
    });
  };

  const deletePopupChange = (data: any) => {
    setDeletePopup({
      showPopup: true,
      popupMessage: "Are you sure you want to delete this Report?",
      popupType: "",
      data: data,
      confirm: false,
    });
  };

  const cancelDelete = () => {
    setDeletePopup({
      showPopup: false,
      popupMessage: "",
      popupType: "",
      data: null,
      confirm: false,
    });
  };
  const confirmDelete = () => {
    var deleteData = { ...deletePopup };
    deleteData["confirm"] = true;
    deleteData["showPopup"] = false;
    setDeletePopup(deleteData);
  };

  // fucntion to display context menu buttons based on set of conditions.
  const DisplayContextMenuButtons = (rowData: any) => {
    let displayButtons = [];
    if (rowData.status === "Draft" && isCentralOrRegionalUser) {
      displayButtons.push(
        <>
          <button
            style={buttonCss}
            className="buttonClass mt-1"
            onClick={() => {
              deletePopupChange(rowData.eventReportId);
            }}
          >
            Delete Event Report
          </button>
          <DeleteConfirmation
            deletePopup={deletePopup}
            cancelDelete={cancelDelete}
            confirmDelete={confirmDelete}
          ></DeleteConfirmation>
        </>
      );
    }
    if (
      !rowData.isPrimaryReviewComplete &&
      rowData.status === "Primary Review"
    ) {
      displayButtons.push(
        <button
          style={buttonCss}
          className="buttonClass mt-1"
          onClick={() => {
            setEventReportId(rowData.eventReportId);
            setPopupName("Primary Review");
            setPopupReadOnly(false);
            setEventTitle(getEventReportTitle(rowData));
            primaryPopup();
          }}
        >
          Perform Primary Review
        </button>
      );
    }
    if (rowData.isPrimaryReviewComplete) {
      displayButtons.push(
        <button
          onClick={() => {
            setEventReportId(rowData.eventReportId);
            getReviewDetails(rowData.eventReportId, "Primary Review");
          }}
          style={buttonCss}
          className="buttonClass mt-1"
        >
          View Primary Review
        </button>
      );
    }
    if (
      rowData.isPrimaryReviewComplete &&
      !rowData.isSecondaryReviewComplete &&
      !isSiteUser
    ) {
      displayButtons.push(
        <button
          style={buttonCss}
          className="buttonClass mt-1"
          onClick={() => {
            setEventReportId(rowData.eventReportId);
            setPopupName("Secondary Review");
            setPopupReadOnly(false);
            primaryPopup();
            setEventTitle(getEventReportTitle(rowData));
            setReviewDetail(rowData)
          }}
        >
          Perform Secondary Review
        </button>
      );
    }
    if (rowData.isPrimaryReviewComplete && rowData.isSecondaryReviewComplete) {
      displayButtons.push(
        <button
          onClick={() => {
            setEventReportId(rowData.eventReportId);
            getReviewDetails(rowData.eventReportId, "Secondary Review");

          }}
          style={buttonCss}
          className="buttonClass mt-1"
        >
          View Secondary Review
        </button>
      );
    }
    if (
      rowData.isPrimaryReviewComplete &&
      !rowData.isInspectionComplete &&
      !isSiteUser
    ) {
      displayButtons.push(
        <button
          onClick={() => {
            setEventReportId(rowData.eventReportId);
            setViewInspection(false);
            inspectionPopup(rowData);
          }}
          style={buttonCss}
          className="buttonClass mt-1"
        >
          Perform Inspection
        </button>
      );
    }
    if (rowData.isInspectionComplete) {
      displayButtons.push(
        <button
          onClick={() => {
            setViewInspection(true);
            inspectionViewPopup(rowData.eventReportId);
          }}
          style={buttonCss}
          className="buttonClass mt-1"
        >
          View Inspection
        </button>
      );
    }
    if (
      rowData.isPrimaryReviewComplete &&
      rowData.hasPrimaryRecommendation &&
      !rowData.isPrimaryRecommendationComplete
    ) {
      displayButtons.push(
        <button
          onClick={() => {
            setEventReportId(rowData.eventReportId);
            setPopupName("Primary Review");
            recommendationPopup();
            setEventTitle(getEventReportTitle(rowData));

          }}
          style={buttonCss}
          className="buttonClass mt-1"
        >
          Complete Primary Recommendation
        </button>
      );
    }
    if (
      rowData.isSecondaryReviewComplete &&
      rowData.hasSecondaryRecommendation &&
      !rowData.isSecondaryRecommendationComplete &&
      !isSiteUser
    ) {
      displayButtons.push(
        <button
          onClick={() => {
            setEventReportId(rowData.eventReportId);
            setPopupName("Secondary Review");
            recommendationPopup();
            setEventTitle(getEventReportTitle(rowData));
          }}
          style={buttonCss}
          className="buttonClass mt-1"
        >
          Complete Secondary Recommendation
        </button>
      );
    }
    return displayButtons;
  };

  const columns = [
    {
      header: "",
      body: (rowData: any) => (
        <>
          <Tooltip target=".edit"></Tooltip>
          <FaRegEdit
            className="edit"
            data-pr-tooltip="Open/Edit Report"
            style={{ cursor: "pointer" }}
            onClick={() => redirectEventReport(rowData)}
          />
        </>
      ),
      sortable: false,
      filter: false,
      filterElement: "filterTextTemplate",
    },
    {
      header: "Event Report Id",
      field: "eventReportId",
      sortable: true,
      filter: true,
      body: (rowData: any) => (
        <>
          {(() => {
            if (rowData.status === "Draft" && !isCentralOrRegionalUser) {
              return (
                <>
                  <button type="button" style={buttonCss} className="pointer">
                    {rowData.eventReportId}
                  </button>
                </>
              );
            } else {
              return (
                <>
                  <OverlayTrigger
                    rootClose
                    flip
                    delay={0}
                    trigger="click"
                    key={rowData.eventReportId}
                    placement="bottom"
                    overlay={
                      <Popover id={`popover-positioned-bottom`}>
                        <Popover.Body>
                          <div>
                            <div style={{ fontSize: "12px" }}>
                              {rowData.eventReportId}
                            </div>
                            {DisplayContextMenuButtons(rowData)}
                          </div>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <button type="button" style={buttonCss}>
                      {rowData.eventReportId}
                    </button>
                  </OverlayTrigger>
                </>
              );
            }
          })()}
        </>
      ),
      filterElement: "filterTextTemplate",
      align: "center"
    },
    {
      header: "DOS",
      field: "dos",
      body: (rowData: any) => {
        const date = SetDateToLocale(new Date(rowData.dos));
        const yyyy = date.getFullYear();
        let mm = (date.getMonth() + 1).toString(); // Months start at 0!
        let dd = date.getDate().toString();

        if (+dd < 10) dd = "0" + dd;
        if (+mm < 10) mm = "0" + mm;

        const formattedDate = mm + "/" + dd + "/" + yyyy;
        return <span>{formattedDate}</span>;
      },
      filterType: "date",
      filterElement: "filterDateTemplate",
    },
    {
      header: "Site Name",
      field: "siteName",
      filterElement: "filterTextTemplate",
    },
    {
      header: "Sub Category",
      field: "subCategory",
      filterElement: "filterTextTemplate",
    },
    {
      header: "Service Line",
      field: "serviceLine",
      filterElement: "filterTextTemplate",
    },
    {
      header: "Gender",
      field: "gender",
      filterElement: "filterDropdownTemplate",
      dropDownOptions: [
        {
          name: "(Blank)",
          value: "null",
        },
        {
          name: "Male",
          value: "Male",
        },
        {
          name: "Female",
          value: "Female",
        },
      ],
      dropDownName: "name",
      dropDownValue: "value",
    },
    {
      header: "Age",
      field: "age",
      filterElement: "filterTextTemplate",
    },
    {
      header: "Age Units",
      field: "ageUnit",
      filterElement: "filterDropdownTemplate",
      dropDownOptions: [
        {
          name: "(Blank)",
          value: "null",
        },
        {
          name: "Months",
          value: "Months",
        },
        {
          name: "Year",
          value: "Year",
        },
      ],
      dropDownName: "name",
      dropDownValue: "value",
    },
    {
      header: "Status",
      field: "status",
      filterElement: "filterDropdownTemplate",
      dropDownOptions: statusOptions,
      dropDownName: "name",
      dropDownValue: "value",
    },
    {
      header: "Review Status",
      field: "reviewStatus",
      filterElement: "filterDropdownTemplate",
      dropDownOptions: reviewStatusOptions,
      dropDownName: "name",
      dropDownValue: "value",
    },
    {
      header: "Region",
      field: "region",
      filterElement: "filterDropdownTemplate",
      dropDownOptions: regionOptions,
      dropDownName: "name",
      dropDownValue: "value",
    },
    {
      header: "Risk Review Status",
      field: "riskReviewStatus",
      filterElement: "filterDropdownTemplate",
      dropDownOptions: [
        {
          name: "Requested",
          value: "Requested",
        },
        {
          name: "Completed",
          value: "Completed",
        },
      ],
      dropDownName: "name",
      dropDownValue: "value",
    },
  ];
  return (
    <>
      {/* <Toast ref={toast}></Toast> */}
      {showLoader ? (
        <>
          <div id="q11">
            <div className="loading">
              <div className="obj"></div>
            </div>
          </div>{" "}
        </>
      ) : null}

      <div className="mainpagetablecontent">
        <Container fluid={true} className="pt-2 pl-2 pr-2">
          <Col md="12" sm="12" xs="12">
            <BreadCrum title="Risk Event Reports" />
          </Col>
  
        </Container>
        <Container fluid={true}>


<div className="row justify-content-end align-items-center"> 

  </div>
       

          <div className="tableBackground p-component">
            {filterLoader ? (
              <>
                <div id="q11">
                  <div className="loading">
                    <div className="obj"></div>
                  </div>
                </div>{" "}
              </>
            ) : null}
            <PTable
              column={columns}
              screen="riskEventReports"
              lazy={true}
              pagination={true}
              reloadTable={reloadTable}
              search={debouncedSearch}
              // updatePrimaryModalState={primaryPopup}
              // toggleShow={inspectionPopup}
              setShowLoader1={setShowLoader}
              reloadData={reloadData}
              setFilterLoader={setFilterLoader}
            />
          </div>
        </Container>
      </div>
      <PrimaryModal
        showPopup={showPrimary}
        updatePrimaryModalState={primaryPopup}
        popupName={popupName}
        reviewDetail={reviewDetail}
        eventReportId={eventReportId}
        readOnly={popupReadOnly}
        eventTitle={eventTitle}
        primaryPopupReadOnly={setPopupReadOnly}
        onExit={setReloadTableVal}
        setReloadCardVal={setReloadCardVal}
      />
      <CompleteRecommendation
        showPopup={showRecommendation}
        updatePrimaryModalState={recommendationPopup}
        popupName={popupName}
        eventTitle={eventTitle}
        eventReportId={eventReportId}
        onExit={setReloadTableVal}
        setReloadCardVal={setReloadCardVal}
      />
      <InspectionModel
        show={showInspection}
        toggleShow={inspectionPopup}
        completionDetails={erRowData}
        eventReportId={eventReportId}
        eventTitle={eventTitle}
        viewOnly={viewInspection}
        onExit={setReloadTableVal}
        setReloadCardVal={setReloadCardVal}
      />
      <CreateEvent
        showPopup={showCreateEvent}
        updateModalState={createEventPopup}
        currentPage={currentPage}
      />
    </>
  );
}
